import { render, staticRenderFns } from "./StringerPallet.vue?vue&type=template&id=3558b902"
import script from "./StringerPallet.vue?vue&type=script&lang=js"
export * from "./StringerPallet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports